// extracted by mini-css-extract-plugin
module.exports = {"root":"figure-module--root--1-Bkt","caption":"figure-module--caption--2OmTe typography-module--small--wmXt7"};